import {Injectable} from "@angular/core";

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  constructor () {}

  signOut(): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.removeItem(USER_KEY);
  }

  public saveToken(token: string): void {
    if (!token || this.isInvalidTokenValue(token)) {
      return;
    }
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  /** JWT or null. Empty, "undefined", and "null" strings are treated as missing. */
  public getToken(): string | null {
    const raw = sessionStorage.getItem(TOKEN_KEY);
    if (this.isInvalidTokenValue(raw)) {
      return null;
    }
    return raw;
  }

  public saveUser(user): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any | null {
    const raw = sessionStorage.getItem(USER_KEY);
    if (raw == null || raw === '') {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  /** True when both a usable token and user snapshot exist. */
  public hasValidSession(): boolean {
    return this.getToken() != null && this.getUser() != null;
  }

  private isInvalidTokenValue(value: string | null): boolean {
    if (value == null) {
      return true;
    }
    const t = value.trim();
    return t === '' || t === 'undefined' || t === 'null';
  }

}
